import { Injectable, Injector } from "@angular/core";
import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from "@angular/common/http";
import { catchError, Observable, of, throwError } from "rxjs";
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { Router } from "@angular/router";
import {InfoMessageService} from '../../services/infomessage/infomessage.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationInterceptor implements HttpInterceptor {

    private token!: string;

    constructor(
        private injector: Injector,
        private router: Router,
        private infoMessageService: InfoMessageService
    ) {
    }

    private get authenticationService(): AuthenticationService {
        return this.injector.get(AuthenticationService);
    }

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 401) {
            this.infoMessageService.createMessage('Sie haben hierzu keine Berechtigung', 'info');
            return of(err.message);
        }

        if (err.status === 403) {
            this.infoMessageService.createMessage(err.error.message, 'error');
            return of(err.message);
        }
        return throwError(err);
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.token = this.authenticationService.getToken();
        if (this.token) {
            const authenticationRequest = request.clone({
                headers: request.headers.set('Authorization', 'Bearer ' + this.token)
            });
            return next.handle(authenticationRequest).pipe(
                catchError(err => this.handleAuthError(err))
            );
        } else {
            return next.handle(request);
        }
    }
}
